import { Component, OnInit, Input, ElementRef, HostListener, ViewEncapsulation, OnDestroy, HostBinding } from '@angular/core';
import { VgAPI, VgFullscreenAPI, VgControlsHidden, VgStates } from 'videogular2/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'vg-overlay-poster',
    encapsulation: ViewEncapsulation.None,
    template: `<div class="vg-overlay-poster" [class.is-playing]="!isCasting && !stopped && getState() !== 'ended'" >
                   <div class="overlay-poster-container" [style.background-image]="'url(' + poster + ')'">
                   </div>
               </div>`,
    styles: [`
        vg-overlay-poster {
            z-index: 100;
        }
        .vg-overlay-poster.is-buffering, .vg-overlay-poster.is-playing {
            display: none;
        }
        vg-overlay-poster .vg-overlay-poster {
            transition: all 0.5s;
            pointer-events: none;
            position: absolute;
            display: block;
            width: 100%;
            height: 100%;
        }
        vg-overlay-poster .vg-overlay-poster .overlay-poster-container {
            width: 100%;
            height: 100%;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            background-size: cover;
        }
    ` ]
})
export class VgOverlayPoster implements OnInit, OnDestroy {
    @Input() vgFor: string;
    @Input() isCasting:boolean;
    @Input() poster: string;
    elem: HTMLElement;
    target: any;
    isNativeFullscreen: boolean = false;    
    subscriptions: Array<any> = [];
    stopped:boolean = true

    @HostBinding('class.is-buffering') isBuffering: boolean = false;
    @HostBinding('class.is-playing') isPlaying: boolean = false;

    constructor(ref: ElementRef, public API: VgAPI, public fsAPI: VgFullscreenAPI, private controlsHidden: VgControlsHidden) {
        this.elem = ref.nativeElement;
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    onPlayerReady() {
        this.target = this.API.getMediaById(this.vgFor);
        //this.poster = this.API.getDefaultMedia().elem.poster;

        this.subscriptions.push(this.fsAPI.onChangeFullscreen.subscribe(this.onChangeFullscreen.bind(this)));
        this.subscriptions.push(this.target.subscriptions.playing.subscribe(this.onPlaying.bind(this)));
        //this.API.getDefaultMedia().subscriptions.ended.subscribe(this.onPlaying.bind(this));;
        this.subscriptions.push(this.target.subscriptions.ended.subscribe(this.onPlaying.bind(this)));
    }

    onChangeFullscreen(fsState: boolean) {
        if (this.fsAPI.nativeFullscreen) {
            this.isNativeFullscreen = fsState;
        }
    }

    onPlaying() {   
        if (!this.target.elem){
            this.isPlaying = false;
        }     
        else if (this.target.elem.ended) {
            this.isPlaying = false;
        }
        else {
            this.isPlaying = true;
            this.stopped = false
        }
    }

    getState() {        
        return this.target ? this.target.state : VgStates.VG_PAUSED;
    }

    ngOnDestroy() {
        this.target = null;
        if(this.subscriptions)
        {
            this.subscriptions.forEach(s => s.unsubscribe());
        }
        
        delete this.elem;
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/controls/video-player-poster.component.ts